module.exports = __webpack_public_path__ + "static/media/IntroSensors.0e094de4.logo";